import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const responseBoardElement = css`
	.CodeMirror {
		height: auto;
		border: 1px solid ${colors.border};
		border-radius: 4px;
		padding: 6px 12px;
		font-size: 16px;
		font-family: inherit;
		color: ${colors.mainText};
	}
`;
